// extracted by mini-css-extract-plugin
export default {"appLogo":"Landing_appLogo__8FlKe","App-logo-spin":"Landing_App-logo-spin__xKkKJ","appHeader":"Landing_appHeader__BoHXq","appLink":"Landing_appLink__1SX7M"};